<script setup lang="ts">
const items = [
  'Approval manual bikin tim menunggu izin.',
  'Paket tertunda karena saldo tidak tersedia tepat waktu.',
  'Rekap manual membuat laporan lambat dan rentan salah.'
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    image-class="lg:order-first"
    title="Setiap Menit Tertunda, Pengiriman Pun Terhambat"
    description="Dalam bisnis & pengiriman, waktu benar-benar berarti. Tapi seringkali, satu kendala kecil — proses pembayaran — bisa menghentikan seluruh alur kerja"
    hero-image="/images/ka-kredit-banner-2.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <Icon
            class="flex-none text-primary"
            name="material-symbols:cancel"
            :size="isMobile ? '22px' : '30px'"
          />
          <p class="text-sm lg:text-lg text-outline">
            {{ item }}
          </p>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
